
import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { PghUserDeviceBase } from 'src/app/shared/device/pgh-user-device';
import { UserClaims } from 'src/app/model/okta/userClaims';
import { GoogleAnalyticsService } from 'src/app/core/services/google-tag-manager.service';
import { combineLatest } from 'rxjs';
import { SelectedDeviceService } from 'src/app/shared/device/selected-device.service';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { PGHOktaService } from 'src/app/core/services/pghokta.service';
import { ADPResourceService } from 'digital-core';
import { StorageService } from 'src/app/core/services/storage.service';
import { UtilityService } from 'src/app/core/services/utility.service';

@Component({
  selector: 'pgh-claims-select-device',
  templateUrl: './claims-select-device.component.html',
  styleUrls: ['./claims-select-device.component.scss']
})
export class ClaimsSelectDeviceComponent implements OnInit, OnDestroy {
  //public claimsDeviceSelectPage: IClaimsSelectDevice;
  public headerText?: string;
  public contractId: string = '';
  public isUserPrimary: boolean = false;
  //public deviceInventoryMfeBaseUrl: string;
  public pghConfig: any;
  public contentInputObject: any = {};
  private programCode: string;
  private accessToken: string;
  private selectedContract: ISelectedContract;
  public isSPOEEnabled = false;
  public hasP360MobilePolicy = false;
  public hasP360HomeTechPolicy = false;
  public isNative: boolean;

  constructor(
    private router: Router,
    private utilityService: UtilityService,
    private selectedDeviceService: SelectedDeviceService,
    private analytics: GoogleAnalyticsService,
    private resourceService: ADPResourceService,
    private loggedInUserSettings: LoggedInUserSettings,
    private activatedRoute: ActivatedRoute,
    public httpClient: HttpClient,
    private pghOktaService: PGHOktaService,
    private storageService: StorageService,
  ) {
  }

  ngOnInit() {
    this.headerText = this.activatedRoute?.snapshot?.data?.headerText ?? '';
    this.programCode = this.resourceService.getPortalSetting("Global_ProgramCode").Value;
    this.accessToken = this.pghOktaService.getAccessToken();;
    this.isSPOEEnabled  = this.resourceService.isPortalSettingTrue('Global_SPOE_Enabled');
    this.hasP360MobilePolicy = this.storageService.getLocal<string>(`EprismContractsCount`) > '0';
    this.hasP360HomeTechPolicy = this.storageService.getLocal<string>(`ElitaContractsCount`) > '0';

    this.activatedRoute.queryParams.subscribe((params) => {
      this.isNative = (params.isNative && params.isNative.toLowerCase().trim() === 'true') || this.utilityService.isNativeApp;
    });

    window.scrollTo(0, 0);

    const joined$ = combineLatest(
      [
        this.loggedInUserSettings.$selectedContract,
        this.loggedInUserSettings.$userClaims
      ]
    ).pipe(
      filter(([a, b]) => a !== null && b !== null)
    );

    joined$.subscribe(([contract, userClaims]: [ISelectedContract, UserClaims]) => {
      this.selectedContract = contract;
      this.contractId = contract.id;
      this.isUserPrimary = this.analytics.isUserPrimary(contract, userClaims);

      // TODO:CS - Check if this needs to be replaced by Client sold policy during claim file for selected device from client sold policy
      this.pghConfig = {
        userAuthJwt: `${this.accessToken}`,
        policyCertificateNumber: this.selectedContract.certificateNumberForGadgetsPolicy,
        programCode: this.programCode,
        dealerCode: this.selectedContract.dealerId,
      };
    });

    /*this.contentInputObject = {
      culture: this.claimsDeviceSelectPage.inventoryCulture,
      siteId: this.claimsDeviceSelectPage.inventorySiteId,
      pageTitle: this.claimsDeviceSelectPage.inventoryPageTitle,
      id: this.claimsDeviceSelectPage.inventoryWidgetId,
      loadingMessage: this.claimsDeviceSelectPage.inventoryLoadingMessage,
      contentLoadingErrorHeading: this.claimsDeviceSelectPage.inventoryContentLoadingErrorHeading,
      contentLoadingErrorMessage: this.claimsDeviceSelectPage.inventoryContentLoadingErrorMessage,
    };*/
  }

  // string out the base url coming from Sitefinity
  formatLinks(text: string) : string {
    const regex = /href="(.*?)"/g;
    const regexInner = /{{(.*)}}/;

    const matches = text.match(regex);
    matches?.forEach(match => {
      const inner = match.match(regexInner);
      text = text.replace(match, `href='${inner[1]}'`);
    });
    return text;
  }

  handleDeviceSelected(event: any) {
    const device: PghUserDeviceBase = {
      deviceId: event.detail.deviceId,
      inventoryId: event.detail.inventoryId,
      coverage: event.detail?.coverage,
      deviceTypeCode: event.detail.deviceTypeCode,
      deviceTypeName: event.detail.deviceTypeName,
      hasReceipt: event.detail.hasReceipt,
      modelIdentifier: event.detail.modelIdentifier,
      nickName: event.detail.nickName,
      make: event.detail.make,
      model: event.detail.model,
    };

    this.selectedDeviceService.setSelectedDevice(device);
    this.router.navigate(['/claims-support']);
  }

  public handleAddDevice(event?: any){
    this.router.navigate(['/my-devices'], { queryParams: { headerKey: 'Claims_DeviceSearch_IsHidden_Key' }, skipLocationChange: true});
  }

  ngOnDestroy() {
    document.documentElement.className = '';
  }
}
